import to from 'await-catch'
import React, { useState } from 'react'
import { Button } from '../../../../components/ui/button'
import { addFlashMessage, hideLoader, showLoader } from '../../../../actions'
import { confirmAppointment, cancelAppointment } from '../../../../api'
import { BackTitle } from '../../EmergencyRoom/styled'
import { ChevronLeft } from '../../../../assets/icons'
import useIsMobile from '../../../../hooks/useIsMobile'
import theme from '../../../../styled/theme'
import { Calendar } from '../../../../assets/icons'
import AddToCalendarQuickAccessModal from '../../../../components/AddToCalendarQuickAccessModal'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { buildAppointmentCalendarEvent } from '../../../../utils/appointmentCalendarEvent'

const ConfirmAppointment = ({ onBack, turn, patient, showLoader, hideLoader, addFlashMessage, auth }) => {
	const history = useHistory()
	const isMobile = useIsMobile()
	const [isConfirmed, setIsConfirmed] = useState(false)
	const [showCalendarModal, setShowCalendarModal] = useState(false)

	const calendarEvent = isConfirmed ? buildAppointmentCalendarEvent(turn) : null


	const confirm = async () => {
		try {
			showLoader()
			const params = {
				clinica: turn.clinica,
				direccionClinica: turn.direccion,
				idEspecialidad: turn.idEspecialidad,
				nombreEspecialidad: turn.nombre,
				idProfesional: turn.idProfesional,
				nombreProfesional: turn.nombreProfesional,
				idObraSocial: patient.idObraSocial,
				coberturaMedica: patient.coberturaMedica,
				plan: patient.planLineaCartilla,
				idPlan: patient.idPlan,
				idPaciente: patient.idPaciente,
				idSistema: '',
				fechaHora: turn.fechaTurnoDateTime,
				nroCobertura: patient.nroCobertura,
				nroAfiliado: patient.nroAfiliado,
				nombreCompletoPaciente: patient.nombreApellido,
				nombrePaciente: patient.nombres,
				nroDocumento: patient.numeroDocumento,
				esVideoconsulta: false,
				idTurno: turn.idTurno,
				Mail: auth.email
			}
			const [err, data] = await to(confirmAppointment(params))

			if (err) throw new Error('Error del servidor')

			setIsConfirmed(true)
		} catch (error) {
			addFlashMessage('Ocurrió un error al confirmar el turno')
		} finally {
			hideLoader()
		}
	}

	return (
		<>
			<AddToCalendarQuickAccessModal
				isOpen={showCalendarModal}
				onClose={() => setShowCalendarModal(false)}
				isFullHeight={isMobile}
				event={calendarEvent}
			/>
			<Container>
				<>
					<ConfirmAppointmentContent>
						<Header>
							{!isConfirmed && !isMobile && (
								<BackTitle m={'0'} onClick={onBack}>
									<ChevronLeft size={8} /> Volver
								</BackTitle>
							)}
							<Title>{isConfirmed ? 'Turno confirmado' : 'Agendar turno'}</Title>
						</Header>

						<ContentWrapper>
							<SectionTitle>Detalle</SectionTitle>
							<DetailsGrid>
								<DetailItem>
									<DetailLabel>Profesional</DetailLabel>
									<DetailValue>{turn.nombreProfesional}</DetailValue>
								</DetailItem>
								<DetailItem>
									<DetailLabel>Especialidad</DetailLabel>
									<DetailValue>{turn.nombreEspecialidad}</DetailValue>
								</DetailItem>
								<DetailItem>
									<DetailLabel>Fecha</DetailLabel>
									<DetailValue>{turn.fechaTurno}</DetailValue>
								</DetailItem>
								<DetailItem>
									<DetailLabel>Dirección</DetailLabel>
									<DetailValue>{turn.direccion}</DetailValue>
								</DetailItem>
							</DetailsGrid>
						</ContentWrapper>
					</ConfirmAppointmentContent>

					{
						<ButtonWrapper>
							{!isConfirmed ? (
								<Button
									type="primary"
									onClick={confirm}
									label="Confirmar"
									size={isMobile ? 'mobile' : 'xlarge'}
								/>
							) : (
								<>
									<Button
										$showBorder={false}
										$mt={'0px'}
										label={'Volver al inicio'}
										$variant="primary"
										size={isMobile ? 'mobile' : 'xlarge'}
										onClick={() => history.push('/inicio')}
									/>
									
									<Button
										iconLeft={<Calendar color={theme.colors.brand.blueOmint} />}
										$showBorder={false}
										$mt={'0px'}
										label={'Agregar a calendario'}
										$variant="secondary"
										size={isMobile ? 'mobile' : 'xlarge'}
										$underline={true}
										onClick={() => setShowCalendarModal(true)}
									/>
								</>
							)}
						</ButtonWrapper>
					}
				</>
			</Container>
		</>
	)
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 80vh;
	width: 80vw;
	padding: 20px;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
		padding: 16px;
		justify-content: space-between;
	}
`

const Header = styled.div`
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	gap: 12px;
	margin-bottom: 24px;
`

const BackButton = styled.button`
	display: flex;
	align-items: center;
	background: none;
	border: none;
	color: ${props => props.theme.colors.brand.blueOmint};
	font-size: 16px;
	cursor: pointer;
	padding: 0;
	font-weight: 500;

	&:hover {
		text-decoration: underline;
	}
`

const Title = styled.h1`
	font-size: 28px;
	font-weight: 600;
	margin: 0;
	color: #333;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		font-size: 24px;
	}
`

const ContentWrapper = styled.div`
	margin-bottom: 24px;
`

const SectionTitle = styled.h2`
	font-size: 16px;
	font-weight: 600;
	color: #333;
	margin: 0 0 16px 0;
	text-transform: none;
`

const DetailsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 28px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		grid-template-columns: 1fr;
		gap: 16px;
	}
`
const DetailItem = styled.div`
	margin-top: auto;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		margin-top: 16px;
	}
	gap: 8px;
`

const DetailLabel = styled.label`
	font-size: 13px;
	font-weight: 600;
	color: #333;
	text-transform: none;
`

const DetailValue = styled.p`
	font-size: 16px;
	color: #666;
	margin: 0;
	font-weight: 400;
`

export const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	gap: 12px;
	width: 360px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		margin-top: 16px;
		width: 100%;
	}
`

export const ConfirmAppointmentContent = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`

function mapStateToProps({ patient, auth }) {
	return { patient, auth }
}

const mapDispatchToProps = {
	showLoader,
	hideLoader,
	addFlashMessage
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAppointment)
